import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
//import Select from 'react-select';
import Select from 'react-dropdown-select'
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
import ReactGA from 'react-ga';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

const { proxy } = require('../../ip_api.config')

class Acc_CreateBom extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bom_no: '',
            bom_description: '',
            db_name: 'DPL',
            arr_show: [],
            arr_save: [],
            showBom: '',
            modalBomLine: false,
            option: [],
            arroption: [],
            selectedOption: null
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/Acc/CreateBom');

        if (localStorage.getItem("ID_User") !== null) {
            this.getItem(this.state.db_name, 0)
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getItem = (db_name, _value) => {
        this.setState({ isLoading: true })

        let arr = []
        let url = proxy.server + '/acc/get_item'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                db_name: db_name,
                value: _value
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push({ value: val.NAMEALIAS, label: val.ITEMID })
                })
                this.setState({ option: arr, isLoading: false }, () => this.showItem(0))
            })
    }

    addItem = () => {
        const { arr_save, bom_no, bom_description, db_name } = this.state
        if (bom_no === "" || bom_description === "" || db_name === "") {
            alert('กรุณากรอกข้อมูลให้ครบ')
        } else {
            let temp

            let data = {
                db_name: db_name,
                user: localStorage.getItem("ID_User"),
                bom_no: bom_no,
                bom_description: bom_description,
                type: '',
                item_group: '',
                item_no: '',
                item_description: '',
            }

            temp = arr_save.concat(data)

            this.setState({
                arr_save: temp
            }, () => {
                console.log('arr_save', this.state.arr_save)
                this.showItem(1)
            })
        }
    }

    showItem = (num) => {
        let arr = []

        this.state.arr_save.forEach(function (val, i) {
            let type = val.bom_no.charAt(0)
            let item_group = type === 'G' ? 'FG' : type === 'H' ? 'HP' : type === 'S' ? 'SM' : type === 'P' ? 'PK' : type === 'S' ? 'SU' : '0'
            arr.push(
                <tr style={{ textAlign: 'center' }}>
                    <td><bs4.Button color="danger" size='sm' onClick={() => this.onDelete(i)}>DEL</bs4.Button></td>
                    {
                        val.db_name === 'DPL' ?
                            <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                            : val.db_name === 'DFIX' ?
                                <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                : val.db_name === 'DPT' ?
                                    <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                    : <td>{val.db_name}</td>
                    }
                    <td>{val.user}</td>
                    <td>{val.bom_no}</td>
                    <td>{val.bom_description}</td>
                    <td>{type}</td>
                    <td>{item_group}</td>
                    <td style={{ textAlign: 'center', width: 300 }}>
                        <Autocomplete
                            id="combo-box-demo"
                            options={this.state.option}
                            getOptionLabel={(option) => option.label}
                            onChange={(event, values) => this.handleChangeItem(event, values, i)}
                            size={'small'}
                            renderInput={(params) => <TextField {...params} label="กรุณาเลือก Item" variant="outlined" onChange={(e) => this.getItem(this.state.db_name, e.target.value)} />}
                        />
                    </td>
                    <td>{val.item_description}</td>
                </tr>
            )

            if (num !== 0) {
                this.state.arr_save[i].item_group = item_group
                this.state.arr_save[i].type = type
            }
        }, this)

        this.setState({
            showBom: arr,
            arr_save: this.state.arr_save
        })
    }

    onDelete = (index) => {
        // this.state.arr_show.splice(index, 1)
        this.state.arr_save.splice(index, 1)
        this.setState({
            // arr_show: this.state.arr_show,
            arr_save: this.state.arr_save,
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.showItem(0)
        })
    }

    handleChangeItem = (event, values, index) => {
        console.log('index', index)
        console.log('values', values)
        if (values === null || values === 'null') {
            let _item = ""
            this.state.arr_save[index].item_no = ""
            this.state.arr_save[index].item_description = ""

            this.setState({
                item_name: _item,
                arr_save: this.state.arr_save,
                selectedOption: ""
            }, () => {
                console.log('arr_save', this.state.arr_save)
                this.showItem(0)
            })
        } else {
            let _item = values.label
            this.state.arr_save[index].item_no = values.label
            this.state.arr_save[index].item_description = values.value

            this.setState({
                item_name: _item,
                arr_save: this.state.arr_save,
                selectedOption: values.label
            }, () => {
                console.log('arr_save', this.state.arr_save)
                this.showItem(0)
            })
        }
    }

    saveItem = () => {
        // console.log('arr', this.state.arr_save)
        let space = 0
        this.state.arr_save.map(function (val, i) {
            if (val.item_no === '') {
                space++
            }
        })

        if (space > 0) {
            alert('กรุณากรอกข้อมูลให้ครบ')
        } else {
            if (window.confirm("กรุณายืนยันการบันทึก")) {
                let url = proxy.server + '/acc/insert_bomVersion'
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    body: JSON.stringify(this.state.arr_save)
                })
                    .then(response => response.json())
                    .then((responseJson) => {
                        console.log("responseJson", responseJson)
                        if (responseJson.status === 201) {
                            this.reload()
                        } else {
                            alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                        }
                    })
            }
        }
    }

    getArrObjInArrObj = (val) => {
        console.log('val', val)
        let arr = this.state.arroption
        let _newArr = []
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].value === val) {
                _newArr.push({
                    value: arr[i].ITEMID + '$' + arr[i].NAMEALIAS, label: arr[i].ITEMID
                })

            }
        }
        console.log('_newArr', _newArr)
        this.setState({ option: _newArr })
    }

    reload = () => {
        window.location.reload()
    }

    render() {
        return <div>
            <Navbar nav={'Acc'} menu={'Acc_CreateBom'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 20, marginTop: 20 }}>
                    <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>เลือกฐานข้อมูล</bs4.Label>
                    <bs4.Col sm='4'>
                        <bs4.Input disabled type="select" name="db_name" onChange={(e) => this.setState({ db_name: e.target.value }, () => { this.getItem(this.state.db_name, 0) })}>
                            <option value="DPL">DPL</option>
                            <option value="DFIX">DFIX</option>
                            <option value="DPT">DPT</option>
                        </bs4.Input>
                    </bs4.Col>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.FormGroup row style={{ marginLeft: 20, marginTop: 20 }}>
                    <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>Bom No</bs4.Label>
                    <bs4.Col sm='4'>
                        <bs4.Input type="text" name="bom_no" onChange={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.setState({ bom_no: e.target.value })} />
                        {/* <Select className="col-md-12"
                            onChange={(e) => this.handleChangeItem(0, 'bom_no', e)}
                            // onKeyDown={(e) => this.getArrObjInArrObj(e.key)}
                            options={this.state.option}
                            placeholder={'ค้นหา Item'}
                        /> */}
                    </bs4.Col>
                    <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>bom_description</bs4.Label>
                    <bs4.Col sm='4'>
                        <bs4.Input type="text" name="bom_description" onChange={(e) => e.target.value.length > 60 ? alert('ห้ามกรอกเกิน 60 ตัวอักษร') : this.setState({ bom_description: e.target.value })} />
                    </bs4.Col>
                    <bs4.Button style={{ fontWeight: 500 }} onClick={() => this.addItem()}>+ ADD</bs4.Button>
                    <bs4.Button color="warning" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.saveItem()}>SAVE</bs4.Button>
                </bs4.FormGroup>
                <br />
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#fec23e', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th></th>
                            <th>ฐานข้อมูล</th>
                            <th style={{ backgroundColor: '#8f8f8f', color: '#000' }}>รหัสพนักงาน</th>
                            <th>Bom No.</th>
                            <th>Bom Description</th>
                            <th style={{ backgroundColor: '#8f8f8f', color: '#000' }}>Type</th>
                            <th style={{ backgroundColor: '#8f8f8f', color: '#000' }}>Item Group</th>
                            <th>Item No.</th>
                            <th >Item Description</th>
                            {/* <th></th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.showBom}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Acc_CreateBom